import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    OnInit,
    Output
} from '@angular/core';

@Component({
    selector: 'app-system-version-update-dialog',
    templateUrl: './system-version-update-dialog.component.html',
    styleUrls: ['./system-version-update-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SystemVersionUpdateDialogComponent implements OnInit {
    @Output() onClickEvent = new EventEmitter<void>();
    @Output() onCancelEvent = new EventEmitter<void>();
    constructor() {}

    ngOnInit() {}

    public onClick(): void {
        this.onClickEvent.emit();
    }

    public onCancel(): void {
        this.onCancelEvent.emit();
    }
}
